module.exports = __webpack_public_path__ + "img/logo.d8db8b5a.f3f2cd9e.png";